"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fix_parent_1 = require("./fix$parent");
var funcParams_1 = require("./funcParams");
var schemaPath_1 = require("./schemaPath");
var cacheFuncs = {};
/**
 * tworzy funkcję obliczającą na podstawie schematu
 * @param schema schemat
 * @param cache czy używać cache
 * @param debug czy dodać debugger, wtedy każde wywołanie funkcji się zatrzymuje
 */
function calcFunction(schema, cache, debug, useStrict) {
    if (cache === void 0) { cache = true; }
    var func = null;
    var calc = schema.calc;
    if (calc) {
        var funcText = schema.calc;
        var cacheKey = funcText;
        var when = '';
        if (calc.when) {
            funcText = calc.func;
            when = calc.when;
        }
        if (cache && !debug) {
            func = cacheFuncs['calc_' + when + '_' + funcText];
            if (func !== undefined) {
                return func;
            }
        }
        var stext = fix_parent_1.default(funcText);
        var ftext = void 0;
        if (debug) {
            ftext = "var result = (" + stext + ");\r\n";
            switch (schema.type) {
                case 'integer':
                    ftext += "result = $methods.mround(result,0);\r\n";
                    break;
                // case 'money': ftext += 'return Math.round($result);'; break;
                case 'money':
                    ftext += "result = $methods.mround(result,2);\r\n";
                    break;
                case 'number':
                    if (schema.precision !== undefined) {
                        ftext += "result = $methods.mround(result," + schema.precision + ");\r\n";
                    }
                    else {
                        // ftext += `return result;`;
                    }
                    break;
                default:
                    // ftext += `return result;`;
                    break;
            }
            if (when) {
                ftext = "if (" + fix_parent_1.default(when) + ") { // when: " + when + "\r\n\r\n" + ftext + "return result;\r\n\r\n}";
            }
            else {
                ftext += 'return result';
            }
            // schemaPath
            // ftext = 'console.debug($obj.$path);\r\ndebugger;\r\n' + ftext;
            ftext = "\r\n/*** debug only ***/\r\n\"" + schemaPath_1.default(schema, true) + "\"; // schema path\r\nconsole.debug($obj.$path); // model path\r\ndebugger;\r\n\r\n/*** function body ***/\r\n" + ftext;
            // ftext = `"${schemaPath(schema, true)}";\r\nconsole.debug($obj.$path);\r\ndebugger;\r\n${ftext}`;
            // ftext = '"' + schemaPath(schema, true) + '";\r\nconsole.debug($obj.$path);\r\ndebugger;\r\n' + ftext;
        }
        else {
            switch (schema.type) {
                case 'integer':
                    ftext = "return $methods.mround((" + stext + "),0);\r\n";
                    break;
                // case 'money': ftext += 'return Math.round($result);'; break;
                case 'money':
                    ftext = "return $methods.mround((" + stext + "),2);\r\n";
                    break;
                case 'number':
                    if (schema.precision !== undefined) {
                        ftext = "return $methods.mround((" + stext + ")," + schema.precision + ");\r\n";
                    }
                    else {
                        ftext = "return (" + stext + ");";
                    }
                    break;
                default:
                    ftext = "return (" + stext + ");";
                    break;
            }
            if (when) {
                ftext = "if (" + fix_parent_1.default(when) + ") {\r\n  " + ftext + "}";
            }
        }
        if (useStrict || process.env.NODE_ENV !== 'production') {
            ftext = '"use strict";\r\n' + ftext;
        }
        func = new Function(funcParams_1.default, ftext);
        if (cache && !debug) {
            cacheFuncs['calc_' + when + '_' + funcText] = func;
        }
    }
    return func;
}
exports.default = calcFunction;
//# sourceMappingURL=calcFunction.js.map